import { OnboardingTooltipActionTypes, SET_VISIBLE_TOOLTIPS } from "./types";

export const setVisibleTooltips = (visibleTooltips: Map<string, HTMLElement>): OnboardingTooltipActionTypes => ({
  type: SET_VISIBLE_TOOLTIPS,
  meta: {
    params: {
      visibleTooltips
    }
  }
});
